<div class="modal-overlay" *ngIf="isModalVisible()">
    <div class="modal-container">
      <div *ngIf="getModalType() == 'loading'" class="spinner-container">
        <mat-spinner></mat-spinner>
        <p class="message">{{ renderMessage() }}</p>
      </div>
      <div *ngIf="getModalType() == 'confirmation'" class="confirmation-container">
        <mat-icon color="primary">check_circle</mat-icon>
        <p>{{ renderMessage() }}</p>
        <button mat-raised-button color="primary" (click)="close()">Continuar</button>
      </div>
    </div>
</div>